import { useContext } from 'react';

import { GameContext, ViewContext } from '@/state/contexts';

import ActionButton from './ActionButton';

import '@/style/HandModal.css';
import { logg } from '@/util/logg';

const TickerActionCluster = () => {
	const {
		isTutorial,
		stepTutorial,
		setStepTutorial,
	}: any = useContext(GameContext);
	const {
		currentTickerIndex,
		setCurrentTickerIndex,
		tickerActual,
		tickerTimeoutSeconds,
		currentTickerTimer,
		toggleTickerTimeout,
	}: any = useContext(ViewContext);

	if (currentTickerIndex >= tickerActual.length) return;

	function nextTicker() {
		clearTimeout(currentTickerTimer);
		setCurrentTickerIndex((prev) => prev + 1);

		logg('isTutorial in nextTicker', isTutorial);
		logg('stepTutorial in nextTicker', stepTutorial);

		if(isTutorial){
			setStepTutorial((prev) => prev + 1);
		}
		logg('stepTutorial after nextTicker', stepTutorial);
	}

	function stopTicker() {
		clearTimeout(currentTickerTimer);
		setCurrentTickerIndex(tickerActual.length);
	}

	return (
		<div className="butt-left">
			<ActionButton
				leftEmoji="⏭️"
				leftText={isTutorial ? "Next Tutorial Step" : "Next Ticker"}
				onClickFunc={() => {
					nextTicker();
				}}
			/>

			{stepTutorial > 100 &&
				<>
					<ActionButton
						leftEmoji="⏱️"
						leftText="Ticker Timeout"
						rightText={`${tickerTimeoutSeconds} sec`}
						onClickFunc={() => {
							toggleTickerTimeout();
						}}
					/>

					<ActionButton
						leftEmoji="❌"
						leftText="Stop Ticker"
						onClickFunc={() => {
							stopTicker();
						}}
					/>
				</>
			}
		</div>
	);
};

export default TickerActionCluster;
